import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {StateService} from "../../../services/StateService";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {State} from "../../../models/State";
import {VendorsService} from "../../../tpiq-services/vendors.service";
import {PageTitleService} from "../../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {TpiqFroalaViewComponent} from "../../../tpiq-froala-view/tpiq-froala-view.component";

declare let _: any;

@Component({
  selector: 'app-view-vendor',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqFroalaViewComponent],
  templateUrl: './view-vendor.component.html',
  styleUrl: './view-vendor.component.scss'
})
export class ViewVendorComponent implements OnInit, OnDestroy {
  user: any;
  org: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  vendor: any = {};
  selectedStrategies: Array<any> = [];
  vendorId: any;
  currentSelectedImage: any;
  showPreview = false;
  documents: Array<any> = [];
  images: Array<any> = [];
  videos: Array<any> = [];
  currentSelectedStrategy: any;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private stateService: StateService,
    private switchBoard: SwitchBoard,
    private titleService: PageTitleService,
    private vendorsService: VendorsService,
    private taxStrategyServices: ManageTaxStrategiesServices,
  ) {}

  ngOnInit() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this._route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params.vendorId) {
        this.vendorId = params.vendorId;
        this.getVendor();
      }
    });

    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      const prevState = this.stateService.getPrevState();
      if (prevState && prevState.key === 'view-vendor') {
        if (prevState.data.fromStrategyPage) {
          let link = [prevState.url, 'vendors'];
          this.stateService.pop();
          this._router.navigate(link);
        } else {
          this.stateService.pop();
          this._router.navigate([prevState.url]);
        }
      } else if (prevState) {
        this.stateService.pop();
        this._router.navigate([prevState.url]);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getVendor() {
    this.loadingService.triggerLoadingEvent(true);
    this.vendorsService.getVendorData(this.org, this.user, this.vendorId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.vendor = response;
        this.titleService.setPageTitle(this.vendor.name);
        if (this.vendor && this.vendor.logo) {
          this.vendor.logoBg = {
            background: 'url("' + this.vendor.logo + '") center center no-repeat',
            'background-size': 'contain'
          };
        }
        this.selectedStrategies = this.getFormatedData(response.strategies);
        if (this.selectedStrategies.length > 0) {
          this.currentSelectedStrategy = this.selectedStrategies[0];
          this.setUpMedia();
        }

      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to get vendor data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  getFormatedData(strategies) {
    const data = _.cloneDeep(strategies);
    _.each(data, (item) => {
      if (item.files) {
        item.files = JSON.parse(item.files);
      } else {
        item['files'] = [];
      }

      if (item.images) {
        item.images = JSON.parse(item.images);
      } else {
        item['images'] = [];
      }

      if (item.videos) {
        item.videos = JSON.parse(item.videos);
      } else {
        item['videos'] = [];
      }

    });

    return data;
  }

  getFileData(file, isForVisualImage?){
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.downloadDocument(this.user, this.org, file.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (isForVisualImage) {
          file.temporaryURL = response.temporaryURL;
          file.fileType = 'image';
        } else {
          window.open(response.temporaryURL);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const errorMessage = (isForVisualImage) ? 'Failed to get image file document' : 'Failed to download document';
        this.toastService.pop(TOAST_TYPE.error, errorMessage);
      });
  }

  showImagePreview(file) {
    this.currentSelectedImage = file;
    this.showPreview = true;
  }

  downloadVideo(video) {
    window.open(video.link);
  }

  showStrategy(strategy) {
    this.stateService.addState(new State('', this._router.url, null, '', null));
    this._router.navigate(['tax-planning', 'taxStrategies', strategy.strategyId]);
  }

  // New View Vendor changes
  selectStrategy(strategy) {
    this.currentSelectedStrategy = strategy;
    this.setUpMedia();
  }

  openOfferLink() {
    const link = this.currentSelectedStrategy.offer.link || '';
    if (link) {
      window.open(link);
    }
  }

  openVendorLink() {
    const link = this.vendor.website || '';
    if (link) {
      window.open(link);
    }
  }

  setUpMedia() {
    this.documents = this.currentSelectedStrategy.files;
    this.images = this.currentSelectedStrategy.images;
    this.videos = this.currentSelectedStrategy.videos;

    if(this.images.length > 0) {
      this.currentSelectedImage = this.images[0];
      this.showPreview = true;
    } else {
      this.currentSelectedImage = '';
      this.showPreview = false;
    }
  }

}
